angular.module('unica_tutorial.tutorial_controllers', [])

.controller('TutorialController', function(
    $scope, TutorialListService
) {

    $scope.tutorialList = [];

    $scope.loadMedia = function() {
        $scope.showLoader();
        $scope.canLoad = false;

        TutorialListService
            .list( )
            .then( function(data) {
                $scope.hideLoader();

                if ( data ) {
                    $scope.tutorialList = $scope.tutorialList.concat( data );
                }
            });
    };

    $scope.loadMedia();


    // $scope.openLightboxModal = function( id )
    // {
    // };


    $scope.showTutorial = function( id )
    {
        TutorialListService
            .preview( $scope.tutorialList[id] )
            .then( function(data) {
                $scope.hideLoader();

                window.open( data );
                // if ( data ) {
                //     $scope.tutorialList = $scope.tutorialList.concat( data );
                // }
            });
    };
});